// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__fGd8Z","breadcrumbs-item":"styles_breadcrumbs-item__zNYzI","link":"styles_link__vTi6C"};